module.exports = __webpack_public_path__ + "img/retry-icon.41325420.svg";